module.exports = __webpack_public_path__ + "img/Loading_r_53.ec1aa510.png";